import Button from '@mui/material/Button';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/store/appStore';
import { STATUS } from '../../utils/status';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { Typography } from '@mui/material';

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  paginate: (pageNumber: number) => void;
  itemsPerPage: number;
}

const ConfigTablePagination: React.FC<PaginationProps> = ({ currentPage, totalPages, paginate, itemsPerPage }) => {

  const config = useSelector((state: RootState) => state.config.config);
  const getStatus = useSelector((state: RootState) => state.config.getConfigStatus);


  return (
    <>
      <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'flex-end' }}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Typography sx={{ color: '#10383D', fontFamily: 'Montserrat', fontSize: '14px', fontWeight: '400', lineHeight: '24px' }}>
            {getStatus === STATUS.SUCESS ? (totalPages > 0 ? ((currentPage - 1) * itemsPerPage + 1) : 0) : '-'} to{' '}
            {getStatus === STATUS.SUCESS
              ? Math.min(currentPage * itemsPerPage, config.count || 0)
              : '-'}{' '}
            of {getStatus === STATUS.SUCESS ? (config.count || 0) : '-'}
          </Typography>
        </div>
        <Button
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
          sx={{ '&:hover': { backgroundColor: 'transparent' } }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ChevronLeftIcon
              sx={{
                color: 'black',
                backgroundColor: currentPage === 1 ? '#F3F5F7' : '#E8EBEE',
                width: '32px',
                height: '32px',
              }}
            />
          </div>
        </Button>
        <Button
          onClick={() => paginate(currentPage + 1)}
          disabled={(currentPage === totalPages) || !(totalPages >= currentPage)}
          sx={{ '&:hover': { backgroundColor: 'transparent' } }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <ChevronRightIcon
              sx={{
                color: 'black',
                backgroundColor: !config.results || config.results.length < itemsPerPage ? '#F3F5F7' : '#E8EBEE',
                width: '32px',
                height: '32px',
              }}
            />
          </div>
        </Button>
      </div>
    </>
  )
}

export default ConfigTablePagination